import { cloneDeep } from 'lodash';
import createTaskType from '../../createTaskType';

import createMdItemsTemplate from './createItemsTemplate';
import MdTaskEditor from './Editor';
import omit from "lodash/omit";

export default createTaskType({
    id: 'minimal_differences',
    label: 'Minimal Differences',
    skill: 'listening',
    v2: true,
    hasRubric: true,

    createItemsTemplate: createMdItemsTemplate,
    editor: MdTaskEditor,

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);
        task = omit(task, ['background_image', 'background_image_2', 'colors', 'final_audio_id']);

        task.items = task.items.map(item => ({
            ...item,
            answers: item.answers.map(answer => ({
                ...answer,
                // Replace empty string with null, as required by API
                text: answer.text || null,
            })),
        }));

        return task;
    },

    getKeys: (item) => {
        return item.answers
            .filter(x => x.is_correct_answer)
            .map(x => `Option ${'ABC'[x.order - 1]} - ${x.image_id}`);
    }
});